// Render-time "now" helper.
//
// All dated rendering goes through `clockNow()` so the firm's ageing maths
// (SLAs, stale fact finds, "days since" labels) keeps moving after deploy
// rather than freezing on an anchored constant. Tests substitute the wall
// clock locally via fake timers — never a global mock — so individual
// snapshot/golden specs can pin their own moment without spilling state
// into unrelated suites.
// Scenario mode only: the scenario server can advance the firm clock so
// time-dependent rendering can be exercised. The offset is mirrored from the
// session payload (SessionProvider is the sole writer); it is 0 in every
// normal build, so `clockNow()` is a plain `new Date()` outside scenario mode.
let scenarioClockOffsetMs = 0;

export function setScenarioClockOffsetMs(offsetMs: number): void {
    scenarioClockOffsetMs = offsetMs;
}

export function clockNow(): Date {
    return scenarioClockOffsetMs === 0 ? new Date() : new Date(Date.now() + scenarioClockOffsetMs);
}

// Whole-day count from now until an ISO date (negative = in the past).
// Render-layer derivation used by the comply due-date pages; goes through
// clockNow() so the ageing maths keeps moving after deploy.
export function daysUntil(iso: string): number {
    return Math.round((new Date(iso).getTime() - clockNow().getTime()) / 86_400_000);
}
